import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { separate } from "../Seprate/Seprate";
import Style from "./PayResult.module.css";
import { pamentInfoPostApi } from "../Api/BarestServices";
import { PointSpreadLoading } from "react-loadingg";
import moment from "moment-jalaali";

const PayResult = () => {
  const history = useHistory();
  const path = window.location.pathname.split("/");
  const [data, setData] = useState();
  const [isSuccess, setIsSuccess] = useState(null); // وضعیت موفقیت

  useEffect(() => {
    infoPaymant();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const infoPaymant = () => {
    let info = {
      id: path[2],
    };
    pamentInfoPostApi(info, (res) => {
      const paymentDetail = res?.detail;
      console.log(paymentDetail)
      // تعیین موفقیت بر اساس شرایط
      if (paymentDetail?.payment_type === "pgw") {
        setIsSuccess(paymentDetail?.payment?.status === "0" && !!paymentDetail?.payment?.cardnumbermasked);
      } else if (paymentDetail?.payment_type === "sadad") {
        setIsSuccess(paymentDetail?.payment?.status === "0" && !!paymentDetail?.payment?.RetrivalRefNo);
      }

      setData(res?.detail);
    });
  };

  if (isSuccess === null) {
    return (
      <div className={Style.SetLoading}>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    );
  }

  return (
    <div className={Style.pageHolder}>
      {isSuccess ? (
        <>
          <div className={Style.imgHolder}>
            <img src={"/Assets/Images/payment/succ.png"} alt="پرداخت موفق" />
          </div>
          <h3 className={Style.succText}>پرداخت با موفقیت انجام شد</h3>
          <div className={Style.infoHolder}>
            <div className={Style.leftCol}>
              <p>{data?.order_id}</p>
              <p className={Style.price}>
                {separate(data?.payment.amount)} تومان
              </p>
              <p>{moment.unix(parseInt(data?.date)).format("jYYYY/jM/jD")}</p>
              <p>{moment.unix(parseInt(data?.date)).format("LT")}</p>
            </div>
            <div className={Style.rightCol}>
              <p>شماره سفارش :</p>
              <p>مبلغ تراکنش :</p>
              <p>تاریخ تراکنش :</p>
              <p>ساعت تراکنش :</p>
            </div>
          </div>
          <div className={Style.btnHolder}>
            <button className={Style.btnSucc} onClick={() => history.push("/")}>
              بازگشت به خانه
            </button>
          </div>
        </>
      ) : (
        <>
          <div className={Style.imgHolder}>
            <img src={"/Assets/Images/payment/error.png"} alt="پرداخت ناموفق" />
          </div>
          <h3 className={Style.failText}>پرداخت ناموفق بود</h3>
          <div className={Style.infoHolder}>
            <div className={Style.leftCol}>
              <p>{data?.order_id}</p>
              <p className={Style.price}>
                {separate(data?.payment.amount)} تومان
              </p>
              <p>{moment.unix(parseInt(data?.date)).format("jYYYY/jM/jD")}</p>
              <p>{moment.unix(parseInt(data?.date)).format("LT")}</p>
            </div>
            <div className={Style.rightCol}>
              <p>کد سفارش :</p>
              <p>مبلغ تراکنش :</p>
              <p>تاریخ تراکنش :</p>
              <p>ساعت تراکنش :</p>
            </div>
          </div>
          <div className={Style.btnHolder}>
            <button
              className={Style.btnError}
              onClick={() => history.push("/")}
            >
              بازگشت به خانه
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default PayResult;
